import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import { Box } from "@material-ui/core";
import TitlePage from '../../common/TitlePage';
import Table from "./table";
import { useDispatch, useSelector } from "react-redux";
import {actionTypes} from './../../../redux/shoab/getBranches/getBranches'


const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '60vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    details: {
        width: '100%',
        margin: 'auto',
        borderRadius: 15,
        padding: "20px 27px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }
    },
    item: {
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        color: "black",
        textAlign: 'center',
        overflow:'auto'
        // fontSize: "1rem",
        // fontWeight: 'bold',
        // overflow: 'auto',
        // "& > div": {
        //     width: "100%",
        //     textAlign: 'center'
        // },

    },
    color: {
        color: theme.palette.light.type2
    },

}));

export default function Index() {

    const classes = useStyles()
    const dispatch = useDispatch();

    const [sort, setSort] = useState({});
    const [state, setstate] = useState([]);
    const [flagApi, setflagApi] = useState(false);
    const [stateTable, setStateTable] = useState({});
    const [pagnation, setPagnation] = useState({ number: 1, count: 2 });


    const stateReducer = useSelector(state => state.get_branches_reducer)
    // const stateReducer = useSelector(state => state.select_shoab_reducer)


    const apiSubmit = () => {
        let obj = {};
        let { size } = stateReducer;
        let { id, ...sortRes } = sort;

        Object.keys(stateTable).forEach((element) => {
            if (stateTable[element]) {
                obj[element] = stateTable[element];
            }
        });

        let _data = {
            data: obj,
            from: pagnation.number,
            size: size,
            sort_by: sortRes,
        };

        dispatch({ type: actionTypes.GetBranchAsync, payload: _data })

    };


    useEffect(() => {
        setstate(stateReducer.data);
        // setPagnation((prev) => ({
        //   ...prev,
        //   count: Math.ceil(stateReducer.total / stateReducer.size),
        // }));
      }, [stateReducer]); //eslint-disable-line react-hooks/exhaustive-deps

      
      useEffect(() => {
     
          apiSubmit();
        
      }, [flagApi])//eslint-disable-line react-hooks/exhaustive-deps

      

    return (
        <Layout>
            <div className={classes['root']}>
                <div className={classes.details}>
                    <Box className={classes.item}>
                        <Table data={state}  loading={stateReducer?.loading}/>
                    </Box>
                </div>
            </div>
        </Layout>
    );
}

